(function () {
    'use strict';

    angular
        .module('blocks.directives')
        .directive('stShowPastEvents', stShowPastEvents)
        .filter("dailySetupFilter", dailySetupFilter);
        
    dailySetupFilter.$inject = ['$filter', '$timeout', 'common'];
    /* @ngInject */
    function dailySetupFilter($filter, $timeout, common) {
        var filterFilter = $filter('filter');
        var standardComparator = function standardComparator(obj, text) {
            text = ('' + text).toLowerCase();
            return ('' + obj).toLowerCase().indexOf(text) > -1;
        };

        return function dailySetupFilter(array, expression) {
            function customComparator(actual, expected) {

                if (angular.isObject(expected)) {

                    //date range
                    if (expected.after) {
                        try {
                            if (actual != '0001-01-01T00:00:00') {
                                var end = moment(actual).toDate();
                                if (end < new Date()) {
                                    return false;
                                }
                            }

                            return true;
                        } catch (e) {
                            return false;
                        }

                    } 
                    return true;

                }
                return standardComparator(actual, expected);
            }

            var output = filterFilter(array, expression, customComparator);
            return output;
        };
    }
   

    /* @ngInject */
    function stShowPastEvents() {
        var directive = {
            restrict: 'A',
            require: '^stTable',
            link: link,
            bindToController: true,
            //controller: 'DailySetupController',
            //controllerAs: 'vm'

        };

        return directive;

        function link(scope, element, attrs, ctrl) {
            
            return element.bind('click', function () {
                return scope.$apply(function () {
                    scope.vm.showHistoricalItems = !scope.vm.showHistoricalItems;
                    var query = {};
                    var predicate = "BuildingLocalReseveredEnd";
                    if (!scope.vm.showHistoricalItems) {
                        query.after = true;
                    }
                    else {
                        query.after = null;
                    }
                 
                    ctrl.search(query, predicate);

                    return ctrl.pipe();
                });
            });
        }
    }
})();
